import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { SectorStore } from 'src/app/shared/services/sector/sector.state';

export const sectorResolver: ResolveFn<boolean> = () => {
  inject(SectorStore).getSectors({});
  return true;
};
